/**src/Data/data.js**/
const HEADER = "Konnect";

const NAVBAR_DATA = [
  { id: 1, url: "/", label: "HOME" },
  { id: 2, url: "/konnect", label: "Konnect" },
  { id: 3, url: "/kct", label: "KCT" },
  // { id: 4, url: "/nft#story", label: "STORY" },
  { id: 5, url: "/nft", label: "NFT Market" },
  { id: 6, url: "#ecommerce", label: "E-Commerce", onClick: () => alert('getting ready!') },
  // { id: 7, url: '/#contact', label: "contactus"}
];
const BANNER_DATA = {
  HEADING1_1: "Beyond Metaverse,",
  HEADING1_2: "Connect Revolution",
  DESCRIPTION1_1: 'Konnect is a Blockchain based Membership Platform',
  DESCRIPTION1_2: 'connecting reality and metaverse via real economy',
  DESCRIPTION2_1: 'Konnect makes',
  DESCRIPTION2_2: 'REVOLUTION',
  DESCRIPTION2_3: 'with You'
};
const SERVICE_DATA = {
  HEADING: "Our Services",
  ALL_SERVICES: "All Services",
  SERVICE_LIST: [
    {
      LABEL: "Search Engine Optimisation",
      DESCRIPTION:
        "To customise the content, technical functionality and scope of your website so that your pages show for a specific set of keyword at the top of a search engine list. In the end, the goal is to attract traffic to your website when they are searching for goods, services or business-related information.",
      URL: "images/service1.png"
    },
    {
      LABEL: "Content Marketing Strategy",
      DESCRIPTION:
        "It is tough but well worth the effort to create clever material that is not promotional in nature, but rather educates and inspires. It lets them see you as a reliable source of information by delivering content that is meaningful to your audience.",
      URL: "images/service2.png"
    },
    {
      LABEL: "Develop Social Media Strategy",
      DESCRIPTION:
        "Many People rely on social networks to discover, research, and educate themselves about a brand before engaging with that organization. The more your audience wants to engage with your content, the more likely it is that they will want to share it.",
      URL: "images/service3.png"
    }
  ]
};

const ABOUT_DATA = {
  HEADING: "\"Connects virtuality and reality\"",
  TITLE1_1: 'KONNECT TOKEN',
  // TITLE1_2: 'Konnect TOKEN',
  SUBTITLE: 'Tickets to meet the new world',
  DESCRIPTION: 'KCT is a membership token that can be used within Konnect World.\nUsers can receive benefits over other payment methods when paying with KCT.\nA separate stablecoin exclusively for payment will be used in the future.\nMembership can be obtained through KCT staking.\nKonnect plans to expand its acceptance as a multi-chain starting with ERC-20.'
};

const MEMBERSHIP_DATA = {
    TITLE: 'MEMBERSHIP',
    DESCRIPTION: 'Users are members of Konnect, not mere buyers.\nThese members are given real benefits, not virtual ones.\nIt will be a platform that grows together, where users also\nbenefit from membership benefits and rewards.\nKonnect most effectively connects\ncryptocurrencies, finance, and real goods and services with users.',
    TITLE2: 'Benefits of being a holder',
    BENEFITS: [
      'Discounts according to grade\nwhen using e-commerce',
      'Separate fee discount\nwhen using NFT Marketplace',
      'When staking for more than 3 months,\nPayback when issuing and using a card',
      'Limited NFT and Mystery Box\nPurchase Opportunities',
      'Rewards according to KCT staking'
    ],
    BUTTON: 'Learn more about MEMBERSHIP',
};

const ECOSYSTEM_DATA = {
  TITLE: "ECOSYSTEM",
  SUBTITLE1_1: "Infrastructure of",
  SUBTITLE_BOLD: "'6 trillion won'",
  SUBTITLE1_2: "in sales already secured",
  DESCRIPTION_TITLE: "'We do not take risky adventures.\n",
  DESCRIPTION: "Konnect already has infrastrcture and customers with annual sales of 6 trillion won. Based on the equipped infrastructure,\nwe will quickly create a real-world token ecosystem. users are memebers of Konnect, not mere buyers.\nThese members are given real benefits, not virutal ones.\nIt will be a platform that grow together, where users also benefit from membership benefits and rewards.\nKonnect most effectively connects cryptocurrencies, finance, and real goods and sercies with users.",
  BUTTON: "Discover the Konnect Ecosystem"
}

const STORY_DATA = {
  TITLE: 'KONNECT STORY',
  DESCRIPTION: "Konnect has put the worldview into the story. It is a concept in which two different erarths in a parallel universe are connected with the energy of Konnect. meet the new world that Konnect will create through the story.",
  STORY1_TITLE: "# 01.Konnect World",
  STORY2_TITLE: "# 02. Birth Of Konnect",
  STORY1_DESCRIPTION: "Numerous Earths in a parallel universe. Among them, K-Earth is where the DUMAN species that created a civilization that is far more advanced than the current Earh is inhabited. They had the technology to user energy indefinately using a material called Konnect.",
  STORY2_DESCRIPTION: "K-Earth, who was building a civilization like Earth, collided with a huge meteorite. The meteorite was made of a materail called Konnect, and Konnect had myserious power and energy. And that power changed everything about K-Earth.",
  BUTTON: "Read more Konnect World STORIES"
}

const NFT_DATA = {
  TITLE: 'NFT MARKETPLACE',
  SUBTITLE: 'Do you own any NFTs?',
  DESCRIPTION: 'The mermaid boy question is just about us Everyone is proud of NFT.\nIt came to us faster than we thought.\nA world where individual jobs are better through the platform.\nMeet the NFT that Konnect connects Konnects\'NFT is via propane KCT',
  NFT1_TITLE: "# 01. Mystery Box",
  NFT1_DESCRIPTION: "The mystery box is a gift from K-Earth. There is a grade for each box, and high-end brand products are randomly displayed in this box, and you can receive the products a s a real product.",
  NFT2_TITLE: "# 02. DUMAN",
  NFT2_DESCRIPTION: "DUMAN, the dominant species of K-Earth, has advanced intelligence under the influence of Konnect. They share the same culture as humans and have similar tastes.",
  BUTTON1: "Buy Mystery Box",
  BUTTON2: "Buy DUMAN NFT"
}

const ECOMMERCE_DATA = {
  TITLE: 'E-COMMERCE',
  DESCRIPTION: 'Through Konnect\'s real infrastructure, KCT users are connected to the real economy.\nVirtual currency, which has been used only as an investment value, has existed only in virtuality. The real economoy is connected through Konnect and its partners. For faster connection, Konnect goes ahead with you.',
  BENEFITS: [
    'Discounts according to grade\nwhen using e-commerce',
    'Separate fee discount\nwhen using NFT Marketplace',
    'When staking for more than 3 months,\nPayback when issuing and using a card',
    'Limited NFT and Mystery Box\nPurchase Opportunities',
    'Rewards according to KCT staking'
  ]
}

const PARTNERS_DATA = {
  TITLE: 'KONNECT PARTNERS',
  DESCRIPTION: "‘We are creating a new world with diverse and powerful partners in the real economy.",
  
}

const ALLOCATION_DATA = {
  TITLE: 'KCT ALLOCATION',
  DESCRIPTION: "‘We are creating a new world with diverse and powerful partners in the real economy.",
}

const ROADMAP_DATA = {
  TITLE: "ROADMAP",
  DATAS_en: [ 
    {
      title: "2022. 4Q",
      list: [        
        "Disclosure of HDC Hyundai Development Hotel & Resort membership benefits",
        "Release of Partnership Utility Card in hotel&culture division",
        "Participation and speaker in BWB 2022",
        "Introduction of Konnect Ambassador",
        "Konnect Wallet feature updates",
        "NFT Marketplace P2P market alpha test",
        "Konnect PFP NFT package sale",
        "Konnect app release beta test"
      ]
    },
    {
      title: "2023. 1Q",
      list: [
        "Global partnership agreements",
        "Disclosure of Konnect Alliance in commerce division",
        "Release of Konnect Wearable Cards",
        "Konnect PFP NFT: New Species Release",
        "NFT Marketplace P2P market beta test",
        "Konnect Hotel Booking system beat test",
        "Konnect app release"
      ]
    },
    {
      title: "2023. 2Q",
      list: [
        "NFT Marketplace P2P alpha for invite-only test users",
        "Konnect PFP NFT: CUMAN story disclosure",
        "Extension of Crypto Booking system to global division",
        "Disclousre of Konnect Alliance in culture division",
        "Launch of Crypto Hotel Booking system",
        "Crypto Airline Booking system alpha test",
        "Mystery Box sale",
        "Airline Booking system beta service",
        "Building a Konnect App community"
      ]
    },        
    {
      title: "2023. 3Q",
      list: [
        "Airline Booking system release",
        "Crypto E-commerce alpha test"
      ]
    },
    {
      title: "2022. 2Q",
      list: [
        "Mystery Box Airdrop Event",
        "Release of Konnect Mystery Boxes",
        "Release of Konnect Product Cards",
        "Physical redemption for Konnect Product Cards",
        "Release of Konnect Event Cards"
      ]
    },
    {
      title: "2022. 3Q",
      list: [
        "Launch of NFT Marketplace (konnect-world.com)",
        "Participation in Korean Blockchain Week",
        "Host in 1st Konnect Seoul VIP Night",
        "Partnership agreements with 28 domestic and foreign companies",
        "Partnership agreements with Hyatt Hotel Seoul, Busan Parkrosh, Oak Vallery Resort, Oakwood Premier COEX Incheon",
        "Participation in Raum Wine Bazaar high-end NFT exhibition",
        "Integration of VIP membership services at Shilla Duty Free",
        "Konnect NFT - Partners Utility Card release",
        "Konnect Shilla Platinum NFT Card release",
        "Disclousre of Konnect Alliance in hotel division",
        "Konnect PFP NFT: Disclousre of DUMAN story",
        "Konnect PFP NFT: Release of DUMAN (5 breeds)",
        "Release and sales of Konnect PFP NFT: Package"
      ]
    },
  ],
  DATAS_kr: [
    {
      title: "2022. 4Q",
      list: [
        "HDC현대산업개발 호텔 앤 리조트 멤버십 혜택 공개",
        "호텔/문화 분야 파트너십 유틸리티 카드 출시",
        "BWB 2022 연사 & 행사 참여",
        "커넥트 엠버서더 도입",
        "커넥트 월렛 고도화 및 기능 추가",
        "NFT 마켓 플레이스 P2P 마켓 알파테스트",
        "커넥트 PFP NFT 패키지 판매",
        "커넥트 앱 출시 베타테스트"
      ]
    },
    {
      title: "2023. 1Q",
      list: [
        "글로벌 파트너십 추가 체결",
        "유통 분야 커넥트 얼라이언스 공개",
        "커넥트 웨어러블 카드 공개",
        "커넥트 PFP NFT: 새 종족 공개",
        "NFT 마켓 플레이스 P2P 마켓 베타테스트",
        "커넥트 호텔 예약 시스템 베타테스트",
        "커넥트 앱 런칭"
      ]
    },
    {
      title: "2023. 2Q",
      list: [
        "NFT 마켓 플레이스 P2P 마켓 커뮤니티 한정 클로즈 오픈",
        "커넥트 PFP NFT: CUMAN 스토리 공개",
        "크립토 예약 시스템 글로벌 사업부 확장",
        "문화 분야 커넥트 얼라리언스 공개",
        "크립트 호텔 예약 시스템 출시",
        "크립토 항공 예약 시스템 알파테스트",
        "미스터리박스 판매",
        "항공 부킹시스템 베타서비스",
        "커넥트 앱 커뮤니티 구축"
      ]
    },    
    {
      title: "2023. 3Q",
      list: [
        "항공 부킹시스템 런칭",
        "크립토 이커머스 알파테스트"
      ]
    },    
    {
      title: "2022. 2Q",
      list: [
        "미스터리 박스 에어드랍 이벤트 진행",
        "커넥트 미스터리 박스 공개",
        "커넥트 상품 카드 공개",
        "커넥트 상품 카드 실물 교환",
        "커넥트 이벤트 카드 공개"
      ]
    },
    {
      title: "2022. 3Q",
      list: [
        "NFT 마켓플레이스 (konnect-world.com) 런칭",
        "Korea Blockchain Week 행사 참여",
        "1st Konnect Seoul VIP Night 개최",
        "국내외 28개사와 업무 협약 체결",
        "하얏트호텔 서울, 부산, 파크로쉬,오크밸리 리조트, 오크우드 프리미어 코엑스,인천 등 호텔부문 파트너십 체결",
        "라움와인바자 하이엔드 NFT 전시회 참여",
        "신라면세점 VIP 멤버십 서비스 연동 및 제공",
        "커넥트 NFT - 파트너 유틸리티 카드 출시",
        "커넥트 신라 플레티넘 NFT 카드 출시",
        "호텔 분야 커넥트 얼라이언스 공개",
        "커넥트 PFP NFT: DUMAN 스토리 공개",
        "커넥트 PFP NFT : 듀먼 (5종) 공개",
        "커넥트 PFP NFT 패키지 출시 및 판매"
      ]
    },
  ],
  DATAS_vn: [
    {
      title: "2022. 4Q",
      list: [        
        "Disclosure of HDC Hyundai Development Hotel & Resort membership benefits",
        "Release of Partnership Utility Card in hotel&culture division",
        "Disclosure of Konnect Alliance in airline division",
        "Participation and speaker in BWB 2022",
        "Introduction of Konnect Ambassador",
        "NFT Mystery Box special exhibition and soft open",
        "Konnect Wallet feature updates",
        "NFT Marketplace P2P market beta",
        "Mystery Box sale",
        "Konnect PFP NFT Package sale",
        "Crypto Hotel Booking system beta"
      ]
    },
    {
      title: "2023. 1Q",
      list: [
        "Global partnership agreements",
        "Disclosure of Konnect Alliance in commerce division",
        "Release of Konnect Wearable Cards",
        "Konnect PFP NFT: New Species Release",
        "NFT Marketplace P2P market beta",
        "Konnect Hotel Booking system beta",
        "Crypto Airline Booking system beta",
        "Konnect E-commerce alpha"
      ]
    },
    {
      title: "2023. 2Q",
      list: [
        "Official launch of Crypto E-commerce B2B sector",
        "NFT Marketplace P2P alpha for invite-only test users",
        "Konnect PFP NFT: CUMAN Story disclosure",
        "Extension of Crypto Booking system to global division",
        'Disclosure of Konnect Alliance in culture division',
        "Launch of Crypto Hotel Booking system",
        "Crypto E-commerce beta",
        "Crypto Airline Booking system beta"
      ]
    },
    {
      title: "2023. 2Q",
      list: [
        "Official launch of Crypto E-commerce B2C sector",
        "Addition in retail item categories in Crypto E-commerce"
      ]
    },
        
    {
      title: "2022. 2Q",
      list: [
        "Mystery Box Airdrop Event",
        "Release of Konnect Mystery Boxes",
        "Release of Konnect Product Cards",
        "Physical redemption for Konnect Product Cards",
        "Release of Konnect Event Cards"
      ]
    },
    {
      title: "2022. 3Q",
      list: [
        "Launch of NFT Marketplace (konnect-world.com)",
        "Partnership agreements with 28 domestic and foreign companies",
        "Host in 1st Konnect Seoul VIP Night",
        "Partnership agreements with 28 domestic and foreign companies",
        "Partnership agreements with Hyatt Hotel Seoul, Busan, Parkosh, Oak Valley Resort, Oakwood Premier COEX Incheon.",
        "Participation in Raum Wine Bazaar high-end NFT exhibition",
        "Integration of VIP membership services at Shilla Duty Free",
        "Konnect NFT - Partners Utlity Card release",
        "Konnect Shilla Platinum NFT Card release",
        "Disclosure of Konnect Alliance in hotel division",
        "Konnect PFP NFT: Disclosure of DUMAN Story",
        "Konnect PFP NFT: Release of  Duman (5 breeds)",
        "Release and sales of Konnect PFP NFT: Package"
      ]
    },
  ],
}

const TESTIMONIAL_DATA = {
  HEADING: "What clients say?",
  TESTIMONIAL_LIST: [
    {
      DESCRIPTION:
        "Nixalar has made a huge difference to our business with his good work and knowledge of SEO and business to business marketing techniques. Our search engine rankings are better than ever and we are getting more people contacting us thanks to Jomer’s knowledge and hard work.",
      IMAGE_URL: "images/user1.jpg",
      NAME: "Julia hawkins",
      DESIGNATION: "Co-founder at ABC"
    },
    {
      DESCRIPTION:
        "Nixalar and his team have provided us with a comprehensive, fast and well planned digital marketing strategy that has yielded great results in terms of content, SEO, Social Media. His team are a pleasure to work with, as well as being fast to respond and adapt to the needs of your brand.",
      IMAGE_URL: "images/user2.jpg",
      NAME: "John Smith",
      DESIGNATION: "Co-founder at xyz"
    }
  ]
};

const SOCIAL_DATA = {
  HEADING: "Find us on social media",
  IMAGES_LIST: [
    "images/facebook-icon.png",
    "images/instagram-icon.png",
    "images/whatsapp-icon.png",
    "images/twitter-icon.png",
    "images/linkedin-icon.png",
    "images/snapchat-icon.png"
  ]
};

const FOOTER_DATA = {
  COPYRIGHT: "Copyright 2022 KCT all rights reserved."
};

const MOCK_DATA = {
  HEADER,
  NAVBAR_DATA,
  BANNER_DATA,
  MEMBERSHIP_DATA,
  ECOSYSTEM_DATA,
  STORY_DATA,
  NFT_DATA,
  ECOMMERCE_DATA,
  PARTNERS_DATA,
  ALLOCATION_DATA,
  ROADMAP_DATA,
  SERVICE_DATA,
  ABOUT_DATA,
  TESTIMONIAL_DATA,
  SOCIAL_DATA,
  FOOTER_DATA
};
export default MOCK_DATA;